/**
 * @generated SignedSource<<c4396efd127ef9835f0fe17b9230c957>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CookieType = "BARC" | "ESSENTIAL" | "THIRDPARTY";
export type ThirdPartyTrackingProviderQuery$variables = {};
export type ThirdPartyTrackingProviderQuery$data = {
  readonly cookies: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly setter: string;
        readonly type: CookieType;
        readonly unsetter: string;
      };
    }>;
  } | null;
};
export type ThirdPartyTrackingProviderQuery = {
  response: ThirdPartyTrackingProviderQuery$data;
  variables: ThirdPartyTrackingProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CookieConnection",
    "kind": "LinkedField",
    "name": "cookies",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CookieEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Cookie",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "setter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unsetter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ThirdPartyTrackingProviderQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ThirdPartyTrackingProviderQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a62baed1717a8f6214277fee965c55db",
    "id": null,
    "metadata": {},
    "name": "ThirdPartyTrackingProviderQuery",
    "operationKind": "query",
    "text": "query ThirdPartyTrackingProviderQuery {\n  cookies {\n    edges {\n      node {\n        id\n        setter\n        unsetter\n        type\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb3e1a33c74bb395382d7ea4f207a165";

export default node;
